module.exports = __webpack_public_path__ + "static/media/hexagon-star.7c1036b4.png";